import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { SplashService } from '../../services/splash/splash.service';
import { LOGO_LOADER } from '../../constants/paths.constant';

@Component({
  selector: 'app-splash-screen-requests',
  standalone: true,
  templateUrl: './splash-screen-requests.component.html',
  styleUrls: ['./splash-screen-requests.component.scss'],
})
export class SplashScreenRequestsComponent {
  positionCss = input<string>('fixed');

  readonly LOGO_SVG = LOGO_LOADER;

  private readonly _splashService = inject(SplashService);

  splashShowRequest = toSignal(
    this._splashService.getSplashScreenRequestObservable,
    { initialValue: false },
  );
}
